(() => {
  const config = window.HEX_SMOOTH_SCROLL || {};
  const unsafePathPattern = /\/(cart|checkout|account|customers|login|register|addresses|wholesale)(\/|$)/i;
  const unsafeTemplateNames = new Set(['cart', 'customers/login', 'customers/register', 'customers/account', 'customers/addresses']);
  const blockingSelectors = [
    '#modals-leftDrawer',
    '#modals-rightDrawer',
    '#modals-quickBuyDrawer',
    '[role="dialog"]',
    '[data-cart-drawer]',
    '.predictive-search-results',
    '[data-filterable-dropdown]',
    '[data-lenis-prevent]',
  ];

  let lenis = null;
  let rafId = null;
  let observer = null;
  let stateQueued = false;

  const isEnabledByConfig = () => config.enabled === true;

  const hasFinePointer = () => (
    window.matchMedia('(hover: hover) and (pointer: fine)').matches
    && !window.matchMedia('(pointer: coarse)').matches
  );

  const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const isUnsafeTemplate = () => {
    const templateName = String(config.templateName || '').toLowerCase();
    const templateSuffix = String(config.templateSuffix || '').toLowerCase();
    const pageType = String(config.pageType || '').toLowerCase();

    return unsafeTemplateNames.has(templateName)
      || templateSuffix === 'wholesale'
      || templateName.includes('customers')
      || pageType.includes('customers');
  };

  const isSafePage = () => (
    isEnabledByConfig()
    && Boolean(window.Lenis)
    && !prefersReducedMotion()
    && hasFinePointer()
    && !unsafePathPattern.test(window.location.pathname)
    && !isUnsafeTemplate()
  );

  const isVisible = (element) => {
    if (!element || element.hidden) return false;

    const style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) {
      return false;
    }

    return element.getClientRects().length > 0;
  };

  const hasBlockingUi = () => blockingSelectors.some((selector) => (
    Array.from(document.querySelectorAll(selector)).some(isVisible)
  ));

  const updateScrollState = () => {
    stateQueued = false;
    if (!lenis) return;

    if (hasBlockingUi()) {
      lenis.stop();
    } else {
      lenis.start();
    }
  };

  const scheduleScrollStateUpdate = () => {
    if (stateQueued) return;
    stateQueued = true;
    window.requestAnimationFrame(updateScrollState);
  };

  const raf = (time) => {
    lenis?.raf(time);
    rafId = window.requestAnimationFrame(raf);
  };

  const scrollToAnchor = (event) => {
    if (!lenis || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    const link = event.target.closest('a[href^="#"]');
    if (!link) return;

    const hash = link.getAttribute('href');
    if (!hash || hash === '#') return;

    const target = document.querySelector(hash);
    if (!target) return;

    event.preventDefault();
    lenis.scrollTo(target, { offset: 0 });
  };

  const destroy = () => {
    observer?.disconnect();
    observer = null;

    if (rafId) {
      window.cancelAnimationFrame(rafId);
      rafId = null;
    }

    document.removeEventListener('click', scrollToAnchor);
    lenis?.destroy();
    lenis = null;
    window.HEXLenis = undefined;
  };

  const init = () => {
    if (!isSafePage() || lenis) return;

    lenis = new window.Lenis({
      lerp: 0.09,
      smoothWheel: true,
      smoothTouch: false,
      wheelMultiplier: 0.85,
    });

    window.HEXLenis = {
      instance: lenis,
      start: () => lenis?.start(),
      stop: () => lenis?.stop(),
      destroy,
      update: scheduleScrollStateUpdate,
    };

    document.addEventListener('click', scrollToAnchor);

    observer = new MutationObserver(scheduleScrollStateUpdate);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'],
      childList: true,
      subtree: true,
    });

    scheduleScrollStateUpdate();
    rafId = window.requestAnimationFrame(raf);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
